import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '../../node_modules/@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  logeado:boolean;
  url;
  
  constructor(private auth:AuthService, private router:Router){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts